import { createContext } from 'react'

const AriaLiveContext = createContext({
    announceAssertive: logContextWarning,
    announcePolite: logContextWarning,
})

function logContextWarning() {
    console.warn('Announcement failed, LiveAnnouncer context is missing')
}

export default AriaLiveContext
